module.exports = __webpack_public_path__ + "img/chocolate-box.1591eb32.svg";